import { Box, Typography } from "@material-ui/core"
import { useIsDesktop } from "common/MediaQueries"
import NextLink from "components/Reusable/Bit/NextLink"
import slugify from "components/Reusable/Bit/utils/slugify"
import DiscountTag from "components/Reusable/DiscountTag"
import styled from "styled-components"

const StyledBox = styled(Box)`
  display: flex;
  align-items: center;
  position: relative;
`

const StyledTitle = styled(Typography).attrs({
  component: "h2",
  variant: "h2",
})`
  color: var(--Black, var(--Primary-Black, #000));
  white-space: nowrap;
  height: 40px;

  display: flex;
  align-items: center;
  justify-content: center;

  font-family: NarkisBlock;
  font-size: 32px;
  font-style: normal;
  line-height: normal;
  font-weight: bold;

  ${(p) => p.theme.breakpoints.down("sm")} {
    padding-right: 16px;
    font-size: 26px;
  }
`

const StyledBonusText = styled(Typography).attrs({
  variant: "body1",
})`
  font-size: 24px;
  font-weight: 400;
  color: #000;
  text-align: start;
  line-height: 0.83;
  background: #ffb900;
  padding: 3px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    font-size: 20px;
    margin-top: 10px;
  }
`

const StyledBonusLine = styled.div`
  width: 1px;
  height: 30px;
  background: #000;
  margin-left: 10px;
  margin-right: 10px;
`

const StyledCategory = styled(Typography).attrs({
  variant: "body1",
  sronly: "See all",
})`
  font-size: 24px;
  color: #264f36;
  text-decoration: underline;
  font-weight: bold;
  font-family: NarkisBlock;
  cursor: pointer;
  ${(p) => p.theme.breakpoints.down("sm")} {
    margin-left: 20px;
  }

  text-decoration: none;

  :hover {
    text-decoration: underline;
  }
`
const StyledCategoryDiv = styled.div`
  justify-content: flex-end;
  position: absolute;
  left: 0;
  display: flex;
`
const StyledBoxWrapperMobile = styled(Box)<{ $visible: boolean }>`
  opacity: ${(p) => (p.$visible ? 1 : 0)};
  transform: ${(p) => (p.$visible ? "none" : "translateX(-1000px)")};
  visibility: ${(p) => (p.$visible ? "visible" : "hidden")};
  transition: opacity 0.6s ease-out, transform 0.6s ease-out;
  will-change: opacity, visibility;
`
const StyledBoxWrapp = styled(Box)`
  display: flex;
  padding-right: 16px;
`

type CategoryNameProps = {
  bonusText?: string
  categoryName: string
  slug: string
  inView: boolean
}

const CategoryName = ({
  bonusText,
  categoryName,
  slug,
  inView,
}: CategoryNameProps) => {
  const isDesktop = useIsDesktop()
  return (
    <StyledBoxWrapperMobile $visible={inView}>
      <StyledBox>
        <StyledTitle>{categoryName}</StyledTitle>
        {bonusText && isDesktop && (
          <>
            <StyledBonusLine />
            <DiscountTag text={bonusText} />
          </>
        )}
        {categoryName !== "הכי פופולרי" && (
          <StyledCategoryDiv>
            <NextLink
              href={`/category/${slugify(slug)}`}
              ariaLabel={`לצפייה בכל סוגי הגיפטקארד בקטגוריה ${slugify(slug)}`}
            >
              <StyledCategory>לצפייה בהכל</StyledCategory>
            </NextLink>
          </StyledCategoryDiv>
        )}
      </StyledBox>
      {bonusText && !isDesktop && (
        <StyledBoxWrapp>
          <StyledBonusText>{bonusText}</StyledBonusText>
        </StyledBoxWrapp>
      )}
    </StyledBoxWrapperMobile>
  )
}

export default CategoryName
